import t from "../../../../i18n/i18n";

import "./styles.css";

export const TooltipItem = ({ item }) => {
  const getQualityName = (id) => {
    switch (id) {
      case 1: {
        return t("Rewards.Tooltip.Quality1Name");
      }
      case 2: {
        return t("Rewards.Tooltip.Quality2Name");
      }
      case 3: {
        return t("Rewards.Tooltip.Quality3Name");
      }
      case 4: {
        return t("Rewards.Tooltip.Quality4Name");
      }
      default: {
        return t("Rewards.Tooltip.Quality5Name");
      }
    }
  };

  return (
    <article className="tooltip-content typo-align-left">
      <header className="card--header">
        <h1 className={`card--header--title typo-h6 quality-${item.info.Quality}-color`}>
          {item.info.Name}

          {item.StrengthenLevel > 0 && ` +${item.StrengthenLevel}`}
        </h1>
      </header>

      {/* <p>
          {`Categoria: ${item.info.CategoryID}`}
          <br />
          {`ID: ${item.info.TemplateID}`}
        </p> */}

      <div className="card-content padding-top-0 typo-body-2" style={{ width: "12rem" }}>
        {
          // <>
          //   {
          //     /* tem validade ? */ true && (
          //       <p className={`typo-weight-medium ${/* limitado ? */ true ? "fg-red" : "fg-green"}`}>
          //         {true ? "Limitado" : "Ilimitado"}
          //       </p>
          //     )
          //   }
          // </>
        }

        <p>
          {item.info.CategoryID === 5 && (
            <>
              <b>{t("Rewards.Tooltip.Armor")}: </b> {item.info.Property7} <br />
            </>
          )}
          {item.info.CategoryID === 14 && (
            <>
              <b>{t("Rewards.Tooltip.Recover")}: </b> {item.info.Property1} <br />
            </>
          )}
          {!!(item.info.CategoryID === 27 || item.info.CategoryID === 7) && (
            <>
              <b>{t("Rewards.Tooltip.Angle")}: </b> {item.info.Property5} ~ {item.info.Property6} <br />
              <b>{t("Rewards.Tooltip.Damage")}: </b> {item.info.Property7} <br />
            </>
          )}
          {item.info.CategoryID === 31 && (
            <>
              {item.info.Property3 === 31 && (
                <>
                  <b>{t("Rewards.Tooltip.Armor")}: </b> {item.info.Property7} <br />
                </>
              )}
              {item.info.Property3 === 32 && (
                <>
                  <b>{t("Rewards.Tooltip.Recover")}: </b> {item.info.Property7} <br />
                </>
              )}
            </>
          )}

          {/* <b>Tipo:</b> {item.info.Category.Name} */}
          <br />
          <span className={`quality-info quality-${item.info.Quality}-color`}>
            <b>{t("Rewards.Tooltip.Quality")}: </b> {getQualityName(item.info.Quality)}
          </span>
        </p>

        {!!(item.info.Attack || item.info.Defence || item.info.Agility || item.info.Luck) && (
          <p>
            {item.info.Attack > 0 && (
              <>
                <b className="fg-red">{t("Rewards.Tooltip.Attack")}: </b>
                {item.info.Attack}
                <br />
              </>
            )}
            {item.info.Defence > 0 && (
              <>
                <b className="fg-light-blue">{t("Rewards.Tooltip.Defense")}: </b>
                {item.info.Defence}
                <br />
              </>
            )}
            {item.info.Agility > 0 && (
              <>
                <b className="fg-light-green">{t("Rewards.Tooltip.Agility")}: </b>
                {item.info.Agility}
                <br />
              </>
            )}
            {item.info.Luck > 0 && (
              <>
                <b className="fg-amber">{t("Rewards.Tooltip.Luck")}: </b>
                {item.info.Luck}
                <br />
              </>
            )}
          </p>
        )}

        {item.info.NeedLevel > 1 && (
          <p className="typo-weight-medium fg-red">{`Nível necessário: ${item.info.NeedLevel}`}</p>
        )}

        {(item.info.CanStrengthen || item.info.CanCompose) && (
          <p className="typo-weight-medium">
            {item.info.CanStrengthen && !item.info.CanCompose && t("Rewards.Tooltip.CanStrengthen")}
            {!item.info.CanStrengthen && item.info.CanCompose && t("Rewards.Tooltip.CanCompose")}
            {item.info.CanStrengthen && item.info.CanCompose && t("Rewards.Tooltip.CanStrengthenAndCanCompose")}
          </p>
        )}

        {item.info.Description && <p className="theme-fg-secondary">{item.info.Description}</p>}

        {/* <p>{item.ValidDate === 0 ? "Permanente" : `${item.ValidDate} dias`}</p> */}
      </div>
    </article>
  );
};

export default TooltipItem;
